
import { createApp } from 'vue'
import siloSelect from '@components/siloSelect.vue'
import TurbolinksAdapter from 'vue-turbolinks'

//////////////////////////////////////////////////////////////////////
// START JS for managing the Country Region Selector for TOT Expense Reports
//////////////////////////////////////////////////////////////////////

export default () => {
  let vueInstance = null
  let country = null
  let countryData = null
  let countryElem = document.getElementById('country-element')
  const hiddenField = document.getElementById('region-hidden-field')
  if (countryElem) {

    countryElem.addEventListener('change', (e) => {
      country = countryElem.options[countryElem.selectedIndex].text
      countryData = window.gon.countries_with_iso3.find(country => country['id'] == countryElem.value)

      if (vueInstance != null) {
        vueInstance.$destroy()
      }

      if (window.gon.countries_with_levels.includes(country)) {
        console.log("inside", country, countryData)

        hiddenField.disabled = false

        const props = {
          level: '1',
          fieldName: 'admin1',
          valueField: 'name',
          hiddenElement: 'region-hidden-field',
          countryCode: countryData.iso3_code,
        }

        if (hiddenField && hiddenField.value){
          props["initialValue"] = { admin1_name: hiddenField.value }
        }

        vueInstance = createApp(siloSelect, props)
        vueInstance.use(TurbolinksAdapter)
        vueInstance.mount('#silo-select')
        // const vueApp = createApp(siloSelect, props)
        // vueApp.mount('#silo-select')
      } else {
        hiddenField.disabled = true
        console.log(hiddenField)
      }
    })

  }


  if (countryElem && countryElem.options[countryElem.selectedIndex].text != '') {
    // let's fire the country change event and let our handler do the rest
    countryElem.dispatchEvent(new Event('change'))
  }

  //////////////////////////////////////////////////////////////////////
  // END JS for managing the Country Region Selector for TOT Expense Reports
  //////////////////////////////////////////////////////////////////////

}